const prefetchedRoutes = new Set<string>()

export function useRoutePrefetch() {
  function prefetchRoute(path: string) {
    if (!import.meta.client || !path || prefetchedRoutes.has(path)) return
    prefetchedRoutes.add(path)
    void preloadRouteComponents(path)
  }

  return { prefetchRoute }
}
